module.exports = new __parcel__URL__("slack-logo.5d730c10.svg").toString();